import React, { useState, useEffect, useCallback } from 'react';
import { walletApi, authApi } from '../../services/api';
import toast from 'react-hot-toast';

export default function Wallet() {
  const [wallets, setWallets] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('overview');
  const [topupForm, setTopupForm] = useState({ userId: '', amount: '', description: '' });
  const [submitting, setSubmitting] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [w, u] = await Promise.all([walletApi.adminAll(), authApi.users()]);
      setWallets(Array.isArray(w) ? w : []);
      setUsers(Array.isArray(u) ? u : []);
    } catch { toast.error('Yüklənilmədi'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const totalBalance = wallets.reduce((s, w) => s + Number(w.balance || 0), 0);
  const getUserName = (userId) => users.find(u => u.id === userId)?.fullName || userId?.slice(0, 8) + '...';
  const getUserPhone = (userId) => users.find(u => u.id === userId)?.phone || '';

  const handleTopup = async e => {
    e.preventDefault();
    const amount = parseFloat(topupForm.amount);
    if (!topupForm.userId) { toast.error('İstifadəçi seçin'); return; }
    if (!amount || amount <= 0) { toast.error('Məbləği düzgün daxil edin'); return; }
    setSubmitting(true);
    try {
      await walletApi.adminTopUp(topupForm.userId, amount, topupForm.description || 'Admin topu');
      toast.success(`${amount} AZN əlavə edildi`);
      setTopupForm({ userId: '', amount: '', description: '' });
      load();
    } catch { toast.error('Xəta baş verdi'); }
    finally { setSubmitting(false); }
  };

  return (
    <div>
      <div style={S.header}>
        <div>
          <h1 style={S.title}>Wallet İdarəsi</h1>
          <p style={S.sub}>Balans və transaksiya idarəsi</p>
        </div>
        <div style={S.tabs}>
          {[['overview', 'İcmal'], ['topup', 'Balans Artır']].map(([t, l]) => (
            <button key={t} style={{ ...S.tab, ...(tab === t ? S.tabActive : {}) }} onClick={() => setTab(t)}>{l}</button>
          ))}
        </div>
      </div>

      <div style={S.statsRow}>
        <div style={S.statCard}>
          <div style={S.statLabel}>Ümumi Wallet</div>
          <div style={S.statVal}>{wallets.length}</div>
        </div>
        <div style={S.statCard}>
          <div style={S.statLabel}>Ümumi Balans</div>
          <div style={{ ...S.statVal, color: 'var(--success)' }}>{totalBalance.toFixed(2)} AZN</div>
        </div>
        <div style={S.statCard}>
          <div style={S.statLabel}>Ort. Balans</div>
          <div style={S.statVal}>{wallets.length ? (totalBalance / wallets.length).toFixed(2) : '0.00'} AZN</div>
        </div>
      </div>

      {tab === 'overview' && (
        <div style={S.card}>
          <h3 style={S.cardTitle}>Bütün Walletlər</h3>
          {loading ? (
            <div style={S.center}>Yüklənir...</div>
          ) : wallets.length === 0 ? (
            <div style={S.empty}>Wallet tapılmadı</div>
          ) : (
            <table style={S.table}>
              <thead>
                <tr>
                  {['İstifadəçi', 'Telefon', 'Balans', 'Valyuta'].map(h => (
                    <th key={h} style={S.th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {wallets.map(w => (
                  <tr key={w.id} style={S.tr}>
                    <td style={S.td}>
                      <div style={S.avatar}>{(getUserName(w.userId)?.[0] || '?').toUpperCase()}</div>
                      <span style={S.name}>{getUserName(w.userId)}</span>
                    </td>
                    <td style={S.td}><span style={S.phone}>{getUserPhone(w.userId)}</span></td>
                    <td style={S.td}>
                      <span style={{ ...S.balance, color: Number(w.balance) > 0 ? 'var(--success)' : 'var(--text3)' }}>
                        {Number(w.balance).toFixed(2)} AZN
                      </span>
                    </td>
                    <td style={S.td}><span style={S.currency}>{w.currency || 'AZN'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {tab === 'topup' && (
        <div style={S.card}>
          <h3 style={S.cardTitle}>İstifadəçiyə Balans Artır</h3>
          <form onSubmit={handleTopup}>
            <div style={S.formRow}>
              <div style={S.field}>
                <label style={S.label}>İstifadəçi *</label>
                <select style={S.select} value={topupForm.userId} onChange={e => setTopupForm({ ...topupForm, userId: e.target.value })} required>
                  <option value="">İstifadəçi seçin...</option>
                  {users.map(u => (
                    <option key={u.id} value={u.id}>{u.fullName} ({u.phone})</option>
                  ))}
                </select>
              </div>
              <div style={S.field}>
                <label style={S.label}>Məbləğ (AZN) *</label>
                <input style={S.input} type="number" min="1" step="0.01" placeholder="50.00"
                  value={topupForm.amount} onChange={e => setTopupForm({ ...topupForm, amount: e.target.value })} required />
              </div>
              <div style={S.field}>
                <label style={S.label}>İzah</label>
                <input style={S.input} placeholder="Promo bonus, düzəltmə..."
                  value={topupForm.description} onChange={e => setTopupForm({ ...topupForm, description: e.target.value })} />
              </div>
            </div>

            <div style={S.quickRow}>
              <span style={{ color: 'var(--text2)', fontSize: 13 }}>Sürətli məbləğlər:</span>
              {[10, 20, 50, 100, 200].map(a => (
                <button key={a} type="button" style={S.quickBtn}
                  onClick={() => setTopupForm({ ...topupForm, amount: String(a) })}>{a} AZN</button>
              ))}
            </div>

            <button style={{ ...S.submitBtn, opacity: submitting ? 0.6 : 1 }} type="submit" disabled={submitting}>
              {submitting ? 'Əlavə edilir...' : '+ Balans Artır'}
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

const S = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 28 },
  title: { fontSize: 26, fontWeight: 800, color: 'var(--text)', marginBottom: 4 },
  sub: { color: 'var(--text3)', fontSize: 14 },
  tabs: { display: 'flex', gap: 8 },
  tab: { background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 16px', color: 'var(--text2)', fontSize: 14, cursor: 'pointer' },
  tabActive: { background: 'var(--primary-glow)', color: 'var(--primary)', borderColor: 'var(--primary)' },
  statsRow: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 24 },
  statCard: { background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: 20 },
  statLabel: { fontSize: 12, color: 'var(--text3)', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.06em' },
  statVal: { fontSize: 28, fontWeight: 800, color: 'var(--text)' },
  card: { background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, padding: 24, marginBottom: 20 },
  cardTitle: { fontSize: 16, fontWeight: 700, color: 'var(--text)', marginBottom: 20 },
  center: { textAlign: 'center', color: 'var(--text3)', padding: 40 },
  empty: { textAlign: 'center', color: 'var(--text3)', padding: 40 },
  table: { width: '100%', borderCollapse: 'collapse' },
  th: { textAlign: 'left', fontSize: 11, color: 'var(--text2)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em', padding: '0 12px 12px', borderBottom: '1px solid var(--border)' },
  tr: { borderBottom: '1px solid var(--border)' },
  td: { padding: '12px', verticalAlign: 'middle', display: 'table-cell' },
  avatar: { width: 32, height: 32, borderRadius: '50%', background: 'var(--primary-glow)', color: 'var(--primary)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700, marginRight: 10, verticalAlign: 'middle' },
  name: { fontSize: 14, fontWeight: 600, color: 'var(--text)', verticalAlign: 'middle' },
  phone: { fontSize: 13, color: 'var(--text2)' },
  balance: { fontSize: 15, fontWeight: 700 },
  currency: { fontSize: 12, color: 'var(--text2)', background: 'var(--bg2)', padding: '3px 8px', borderRadius: 6 },
  formRow: { display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 16, marginBottom: 16 },
  field: { display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 11, color: 'var(--text2)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.06em' },
  input: { background: 'var(--input-bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 12px', color: 'var(--text)', fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box' },
  select: { background: 'var(--input-bg)', border: '1px solid var(--border)', borderRadius: 8, padding: '10px 12px', color: 'var(--text)', fontSize: 14, outline: 'none', width: '100%', boxSizing: 'border-box' },
  quickRow: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 20, flexWrap: 'wrap' },
  quickBtn: { background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 8, padding: '6px 14px', color: 'var(--text2)', fontSize: 13, cursor: 'pointer' },
  submitBtn: { background: 'var(--primary)', color: 'var(--bg)', border: 'none', borderRadius: 8, padding: '12px 24px', fontWeight: 700, cursor: 'pointer', fontSize: 15 },
};
